module.exports = __webpack_public_path__ + "img/aa-mb.e30d0853.png";